/* ============================================================
   BIKE-SHOP CUSTOM THEME JS
   ============================================================ */

(function() {
  'use strict';

  /* --- Mega Menu Toggle --- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var megaMenu = document.querySelector('[data-mega-menu]');

  if (menuToggle && megaMenu) {
    menuToggle.addEventListener('click', function() {
      var isOpen = megaMenu.classList.contains('is-open');
      megaMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(!isOpen));

      var svg = menuToggle.querySelector('svg');
      if (!isOpen) {
        svg.innerHTML = '<line x1="6" y1="6" x2="18" y2="18"/><line x1="6" y1="18" x2="18" y2="6"/>';
        closeSearch();
      } else {
        svg.innerHTML = '<line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>';
      }
    });
  }

  /* --- Inline Search --- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var headerSearch = document.querySelector('[data-header-search]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchClose = document.querySelector('[data-search-close]');

  function openSearch() {
    if (!headerSearch) return;
    headerSearch.classList.add('is-open');
    closeMegaMenu();
    setTimeout(function() {
      if (searchInput) searchInput.focus();
    }, 300);
  }

  function closeSearch() {
    if (!headerSearch) return;
    headerSearch.classList.remove('is-open');
    if (searchInput) searchInput.value = '';
  }

  function closeMegaMenu() {
    if (!megaMenu) return;
    megaMenu.classList.remove('is-open');
    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'false');
      var svg = menuToggle.querySelector('svg');
      if (svg) svg.innerHTML = '<line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>';
    }
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function() {
      var isOpen = headerSearch && headerSearch.classList.contains('is-open');
      if (isOpen) {
        closeSearch();
      } else {
        openSearch();
      }
    });
  }

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  /* --- Cart Drawer --- */
  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartClose = document.querySelector('[data-cart-close]');

  function openCartDrawer() {
    if (!cartDrawer || !cartOverlay) return;
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
    cartDrawer.classList.add('is-open');
    cartOverlay.classList.add('is-open');
    document.body.classList.add('drawer-open');
    closeMegaMenu();
    closeSearch();
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.remove('is-open');
    cartOverlay.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    document.body.style.removeProperty('--scrollbar-width');
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  if (cartClose) {
    cartClose.addEventListener('click', closeCartDrawer);
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }

  /* --- Language Switcher --- */
  var langToggle = document.querySelector('[data-lang-toggle]');
  var langDropdown = document.querySelector('[data-lang-dropdown]');

  function closeLangDropdown() {
    if (!langDropdown || !langToggle) return;
    langDropdown.classList.remove('is-open');
    langToggle.setAttribute('aria-expanded', 'false');
  }

  if (langToggle && langDropdown) {
    langToggle.addEventListener('click', function() {
      var isOpen = langDropdown.classList.contains('is-open');
      if (isOpen) {
        closeLangDropdown();
      } else {
        langDropdown.classList.add('is-open');
        langToggle.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-lang-switcher]')) {
        closeLangDropdown();
      }
    });
  }

  /* Close panels on Escape key */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeMegaMenu();
      closeSearch();
      closeCartDrawer();
      closeLangDropdown();
    }
  });

  /* --- Quantity Buttons (Product Detail + Cart Drawer) --- */
  document.addEventListener('click', function(e) {
    var minus = e.target.closest('[data-quantity-minus], [data-cart-quantity-minus]');
    var plus = e.target.closest('[data-quantity-plus], [data-cart-quantity-plus]');

    if (minus) {
      var input = minus.parentElement.querySelector('input[type="number"]');
      if (input) {
        var min = parseInt(input.min) || 0;
        var val = parseInt(input.value) || 1;
        if (val > min) input.value = val - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (plus) {
      var input = plus.parentElement.querySelector('input[type="number"]');
      if (input) {
        input.value = (parseInt(input.value) || 0) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  /* --- Cart Quantity Update (Ajax) --- */
  document.addEventListener('change', function(e) {
    var input = e.target.closest('[data-cart-quantity-input]');
    if (!input) return;

    var line = parseInt(input.dataset.line);
    var quantity = parseInt(input.value) || 0;

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(res) { return res.json(); })
    .then(function() { location.reload(); });
  });

  /* --- Cart Remove --- */
  document.addEventListener('click', function(e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();

    var item = remove.closest('[data-cart-item]');
    var line = parseInt(item.dataset.line);

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(function(res) { return res.json(); })
    .then(function() { location.reload(); });
  });

  /* --- Variant Selection (Product Detail) --- */
  var productForm = document.querySelector('[data-product-form]');

  if (productForm) {
    var productJson = document.querySelector('[data-product-json]');
    var productData = null;

    if (productJson) {
      try { productData = JSON.parse(productJson.textContent); } catch(e) {}
    }

    var optionSelects = productForm.querySelectorAll('[data-option-index]');

    optionSelects.forEach(function(select) {
      select.addEventListener('change', function() {
        if (!productData) return;

        var selectedOptions = [];
        optionSelects.forEach(function(s) {
          selectedOptions.push(s.value);
        });

        var matchedVariant = productData.variants.find(function(v) {
          return v.options.every(function(opt, i) {
            return opt === selectedOptions[i];
          });
        });

        if (matchedVariant) {
          var variantInput = productForm.querySelector('[data-variant-id]');
          if (variantInput) variantInput.value = matchedVariant.id;

          var priceEl = document.querySelector('[data-product-price]');
          if (priceEl) {
            var formatted = Shopify.formatMoney(matchedVariant.price);
            priceEl.innerHTML = formatted;
          }

          var url = new URL(window.location);
          url.searchParams.set('variant', matchedVariant.id);
          history.replaceState({}, '', url);
        }
      });
    });
  }

  /* --- Collection Sort --- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', this.value);
      window.location = url.toString();
    });
  }

  /* --- Cart Count Update (header badge) --- */
  function updateCartCount(count) {
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function(badge) {
      badge.textContent = count;
      badge.dataset.cartCount = count;
      badge.hidden = count === 0;
    });
  }

  /* --- Product Form Ajax Submit --- */
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var formData = new FormData(form);
    var data = {
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity')) || 1
    };

    var btn = form.querySelector('[type="submit"]');
    var addText = btn ? (btn.dataset.addText || 'Add to cart') : 'Add to cart';
    var addingText = btn ? (btn.dataset.addingText || 'Adding...') : 'Adding...';
    var addedText = btn ? (btn.dataset.addedText || 'Added!') : 'Added!';
    if (btn) {
      btn.disabled = true;
      btn.textContent = addingText;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      return fetch(window.Shopify.routes.root + 'cart.js');
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      if (btn) {
        btn.textContent = addedText;
        setTimeout(function() {
          btn.disabled = false;
          btn.textContent = addText;
        }, 1500);
      }
      openCartDrawer();
    })
    .catch(function() {
      if (btn) {
        btn.disabled = false;
        btn.textContent = addText;
      }
    });
  });

  /* --- Hero Slideshow --- */
  var heroEl = document.querySelector('[data-hero-slideshow]');
  if (heroEl) {
    var slides = heroEl.querySelectorAll('.hero__slide');
    var navItems = heroEl.querySelectorAll('[data-hero-dot]');
    var intervalSec = parseInt(heroEl.dataset.interval) || 5;
    var intervalMs = intervalSec * 1000;
    var current = 0;
    var timer = null;

    heroEl.style.setProperty('--hero-interval', intervalSec + 's');

    function resetProgress(item) {
      var progress = item.querySelector('.hero__nav-progress');
      if (progress) {
        progress.style.animation = 'none';
        progress.offsetHeight;
        progress.style.animation = '';
      }
    }

    function goToSlide(index) {
      slides[current].classList.remove('is-active');
      if (navItems[current]) navItems[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      if (navItems[current]) {
        navItems[current].classList.add('is-active');
        resetProgress(navItems[current]);
      }
    }

    function nextSlide() {
      goToSlide((current + 1) % slides.length);
    }

    function startAutoPlay() {
      if (slides.length > 1) {
        timer = setInterval(nextSlide, intervalMs);
      }
    }

    function stopAutoPlay() {
      if (timer) clearInterval(timer);
    }

    navItems.forEach(function(item) {
      item.addEventListener('click', function() {
        stopAutoPlay();
        goToSlide(parseInt(this.dataset.heroDot));
        startAutoPlay();
      });
    });

    if (navItems[0]) resetProgress(navItems[0]);
    startAutoPlay();
  }

  /* --- Product Card Title Overflow Detection --- */
  function detectTitleOverflow() {
    var titles = document.querySelectorAll('.product-card__title');
    titles.forEach(function(title) {
      var text = title.querySelector('.product-card__title-text');
      if (!text) return;
      if (text.scrollWidth > title.clientWidth) {
        title.classList.add('is-overflowing');
        var overflow = text.scrollWidth - title.clientWidth;
        title.style.setProperty('--title-overflow', '-' + overflow + 'px');
        var duration = Math.max(1, overflow / 60);
        title.style.setProperty('--title-scroll-duration', duration + 's');
      } else {
        title.classList.remove('is-overflowing');
      }
    });
  }

  detectTitleOverflow();
  window.addEventListener('resize', detectTitleOverflow);
})();
